export var isPreRelease = (process.env.FINECT_FLAG_PRERELEASE || 'false') === 'true';